import { AnimatePresence, motion } from 'framer-motion'

import Portal from '../../utils/portals/portal'

type DashboardModalProps = {
  children: React.ReactNode
  onClose: () => void
  open: boolean
}

const DashboardModal = ({ children, onClose, open }: DashboardModalProps) => {
  const _onClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()
    onClose()
  }

  return (
    <Portal>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/70"
            onClick={_onClose}
          >
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
              <div className="pointer-events-auto" onClick={(e) => e.stopPropagation()}>
                {children}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal>
  )
}

export default DashboardModal
